module.exports = __webpack_public_path__ + "static/headphones-top-banner-section-code-6a11a59e52da84ac9b2589942b88ce9e.png";